'use client';

import { useRouter } from 'next/navigation';
import { useAuth } from '@/contexts/auth';
import { useEmbedBackPath, useIsEmbed } from '@/contexts/embed';

export function useGoBack() {
  const router = useRouter();
  const { isAuthenticated } = useAuth();
  const isEmbed = useIsEmbed();
  // Site navigation answers with frame-ancestors 'self', so an embed can only
  // go back to the list embed that opened this page — and a single-item embed
  // was opened by nobody.
  const embedBackPath = useEmbedBackPath();
  const homePath = isAuthenticated ? '/dashboard' : '/';
  const hasBack = !isEmbed || !!embedBackPath;

  const goBack = (fallback?: string) => {
    if (embedBackPath) {
      router.push(embedBackPath);
      return;
    }

    const prevUrl = sessionStorage.getItem('prevUrl');

    if (prevUrl) {
      router.back();
    } else {
      router.replace(fallback ?? homePath);
    }
  };

  return { goBack, homePath, hasBack };
}
